<template>
  <div class="fixed bottom-4 left-4 z-[1000]">
    <div class="flex items-center gap-2">
      <FloatingDarkModeToggle />
      <FloatingLanguageSwitch />
    </div>
  </div>
</template>

<script setup lang="ts">
import FloatingLanguageSwitch from '@/components/custom/language-switch/FloatingLanguageSwitch.vue'
import FloatingDarkModeToggle from '@/components/custom/darkmode-toggle/FloatingDarkModeToggle.vue'
</script>
